import { render, staticRenderFns } from "./RankCell.vue?vue&type=template&id=18629762&scoped=true&"
import script from "./RankCell.vue?vue&type=script&lang=js&"
export * from "./RankCell.vue?vue&type=script&lang=js&"
import style0 from "./RankCell.vue?vue&type=style&index=0&id=18629762&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18629762",
  null
  
)

export default component.exports